/* eslint-disable react/prop-types */
import React, { useState } from "react"; // React Stuff
import axios from "axios";
import { Col, Row, Form, Button, Table } from "react-bootstrap";
import { Link } from "react-router-dom";

const ClassTransferSubscription = (props) => {
  // Search String State and results
  const [search, setSearch] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  // Transfer State
  const [previousClass, setPreviousClass] = useState("");
  // viewed classID
  const classid = props.data._id;
  // Do the Search
  const handleSearchSubmit = async (e) => {
    e.preventDefault();
    const classid = props.data._id;
    const searchRequest = await axios.get(
      `/api/admin/manage/get_subscription/${search}/${classid}`,
      {
        withCredentials: true,
      }
    );
    if (searchRequest.status === 200) {
      props.setSubmitClicked(false);
      return setSearchResults(searchRequest.data);
    } else {
      props.setSubmitClicked(false);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };
  //Transfer with notification
  const handleSubscriptionToMoveSubmit = async (
    stripe_subscription_id,
    previousClassID,
    emailSetting,
    e
  ) => {
    e.preventDefault();
    const transferRequestwithEmail = await axios.put(
      `/api/admin/manage_subscription/move_subscription/${classid}`,
      {
        stripe_subscription_id,
        emailSetting,
      },
      {
        withCredentials: true,
      }
    );
    if (transferRequestwithEmail.status === 200) {
      props.setSubmitClicked(false);
      window.scrollTo(10, 0);
      setSearch("");
      setSearchResults([]);
      props.setSuccessMessage("The subscription was successfully transferred.");
      setPreviousClass(previousClassID);
      return props.fetchNewData();
    } else {
      props.setSubmitClicked(false);
      window.scrollTo(10, 0);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };
  return (
    <Row className='mt-4 mb-4 text-center'>
      <Col className='border shadow p-3'>
        <Form className='mt-4' onSubmit={handleSearchSubmit}>
          <Row>
            <Col lg='11'>
              <Form.Group controlId='NameBox'>
                <Form.Control
                  type='text'
                  maxLength='256'
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col lg='1'>
              <Button variant='info' type='submit' className='mb-2 mt-2'>
                Search
              </Button>
            </Col>
          </Row>
        </Form>
        <p>
          Try filtering in quotes such as &quot;John Smith&quot; if your initial search doesn&apos;t
          turn up anything.
        </p>
        {searchResults.length > 0 ? (
          <Table striped bordered hover responsive className='text-center'>
            <thead>
              <tr>
                <th>Name</th>
                <th>Transfer</th>
                <th>No Notification</th>
              </tr>
            </thead>
            <tbody>
              {searchResults.map((Subscription) => (
                <tr key={Subscription._id}>
                  <td className='align-self-center align-middle'>
                    <small>
                      <Link to={`/admin/customer-list/${Subscription.SystemUserID}`}>
                        {Subscription.Participant_Name}
                      </Link>
                      <br />
                      {Subscription.StripeStatus}
                      <br />
                      {Subscription.ClassLessonType} on {Subscription.ClassDay}
                    </small>
                  </td>
                  <td className='align-self-center align-middle'>
                    <Button
                      variant='secondary'
                      size='sm'
                      type='submit'
                      disabled={props.submitClicked}
                      onClick={(e) =>
                        handleSubscriptionToMoveSubmit(
                          Subscription.stripe_subscription_id,
                          Subscription.ClassID,
                          "true", // Email Setting
                          e
                        )
                      }
                    >
                      Transfer
                    </Button>
                  </td>
                  <td className='align-self-center align-middle'>
                    <Button
                      variant='warning'
                      size='sm'
                      type='submit'
                      disabled={props.submitClicked}
                      onClick={(e) =>
                        handleSubscriptionToMoveSubmit(
                          Subscription.stripe_subscription_id,
                          Subscription.ClassID,
                          "false", // Email Setting
                          e
                        )
                      }
                    >
                      Transfer
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          ""
        )}
        {previousClass !== "" && (
          <div className='text-center border mb-3 pt-3 pl-3'>
            <p>
              Your transfer may have have opened up a space on the waiting list of the previous
              class.
            </p>
            <Button
              variant='info'
              size='sm'
              className='mb-3'
              as={Link}
              to={`/admin/classes/${previousClass}/`}
            >
              Go to class
            </Button>
            <br />
            <Button
              variant='info'
              size='sm'
              className='mb-3'
              value={""}
              onClick={(e) => setPreviousClass(e.target.value)}
            >
              No, thank you.
            </Button>
          </div>
        )}
      </Col>
    </Row>
  );
};

export default ClassTransferSubscription;
